export default {
    url: '/survey/:guid',
    template: '<ui-view></ui-view>',
    abstract: true,
    resolve: {
        surveyGroup (SurveyGroupResource, $stateParams) {
            return SurveyGroupResource.publicView({ guid: $stateParams.guid }).$promise;
        }
    },
    controller ($rootScope, surveyGroup) {
        $rootScope.surveyGroup = surveyGroup;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/survey/survey/index.js